export default "__VITE_ASSET__BcDAQPrF__"